import { useState, useEffect, useCallback } from "react";
import { mapBrandByIndexLetter } from "./mappers";
import { getGiftCardBalanceList } from "./requests";

export const useGetGiftCardBalanceList = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [giftCardBalanceListByLetter, setGiftCardBalanceListByLetter] =
    useState(null);

  const getBalanceList = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await getGiftCardBalanceList();
      const balanceListGroupedByLetter = mapBrandByIndexLetter(response);
      setGiftCardBalanceListByLetter(balanceListGroupedByLetter);
    } catch (error) {
      setGiftCardBalanceListByLetter(null);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    void getBalanceList();
  }, [getBalanceList]);

  return {
    isLoading,
    giftCardBalanceListByLetter
  };
};
